export type BybitInstrument = {
  symbol: string
  baseCoin?: string
  quoteCoin?: string
  status?: string
  name?: string
}

export async function fetchBybitSpotSymbols(): Promise<BybitInstrument[]> {
  const url = 'https://api.bybit.com/v5/market/instruments-info?category=spot&limit=1000'
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Bybit API error: ${res.status}`)
  const json = await res.json()
  const list = (json?.result?.list ?? []) as any[]
  return list.map((it) => ({ symbol: it.symbol as string, baseCoin: it.baseCoin, quoteCoin: it.quoteCoin, status: it.status }))
}

// Older public endpoint that includes showName/name for some symbols
async function fetchBybitSpotSymbolsV3(): Promise<Record<string, { name?: string }>> {
  try {
    const url = 'https://api.bybit.com/spot/v3/public/symbols'
    const res = await fetch(url)
    if (!res.ok) return {}
    const json = await res.json()
    const rows: any[] = json?.result?.list ?? []
    const map: Record<string, { name?: string }> = {}
    for (const r of rows) {
      const sym = r?.name || r?.symbol
      if (sym) map[sym] = { name: r?.showName || r?.alias || r?.baseCoin || undefined }
    }
    return map
  } catch {
    return {}
  }
}

export async function fetchBybitSpotSymbolsDetailed(): Promise<BybitInstrument[]> {
  const [v5, v3] = await Promise.all([fetchBybitSpotSymbols(), fetchBybitSpotSymbolsV3()])
  return v5.map((i) => ({ ...i, name: v3[i.symbol]?.name }))
}

// Linear Perp USDT instruments (derivatives) — used to ensure compatibility with our collectors
export async function fetchBybitLinearUSDTInstruments(): Promise<BybitInstrument[]> {
  const url = 'https://api.bybit.com/v5/market/instruments-info?category=linear&limit=1000'
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Bybit API error: ${res.status}`)
  const json = await res.json()
  const list = (json?.result?.list ?? []) as any[]
  return list
    .filter((it) => String(it.quoteCoin || '').toUpperCase() === 'USDT')
    .map((it) => ({ symbol: it.symbol as string, baseCoin: it.baseCoin, quoteCoin: it.quoteCoin, status: it.status }))
}
